// src/components/BottomNav.tsx
import { useNavigate, useLocation } from 'react-router-dom';
import { FiCheckCircle, FiHome, FiUser } from 'react-icons/fi';

type Tab = 'home' | 'nba' | 'nhl' | 'tracker' | 'profile';

function BasketballIcon({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 2.7c-2.6 2-4.1 5.1-4.1 9.3s1.5 7.3 4.1 9.3M12 2.7c2.6 2 4.1 5.1 4.1 9.3s-1.5 7.3-4.1 9.3M2.7 12c2 0 4.2.6 6.2 1.7s3.5 2.5 4.4 4.5M21.3 12c-2 0-4.2.6-6.2 1.7s-3.5 2.5-4.4 4.5" />
    </svg>
  );
}

function HockeyIcon({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M7.44 2.4 14.9 17.5c.56 1.13 1.52 1.66 2.76 1.4l3.04-.66M14.9 17.5q1.2 2 4.56 1.2" />
      <ellipse cx="16.3" cy="21.15" rx="2.4" ry=".62" fill="currentColor" stroke="none" />
    </svg>
  );
}

const tabs: { id: Tab; icon: React.ReactNode; label: string }[] = [
  { id: 'home', icon: <FiHome size={22} />, label: 'Início' },
  { id: 'nba', icon: <BasketballIcon />, label: 'NBA' },
  { id: 'nhl', icon: <HockeyIcon />, label: 'NHL' },
  { id: 'tracker', icon: <FiCheckCircle size={23} />, label: 'Tracker' },
  { id: 'profile', icon: <FiUser size={22} />, label: 'Perfil' },
];

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const active = (() => {
    const path = location.pathname.replace('/', '');
    return (tabs.find(t => t.id === path)?.id ?? (path === 'bankroll' ? 'tracker' : 'home')) as Tab;
  })();

  const handleTab = (tab: Tab) => {
    navigate(tab === 'home' ? '/' : `/${tab}`);
  };

  return (
    <nav className="bottom-nav" aria-label="Navegação principal" style={{
      position: 'fixed', bottom: 'calc(10px + env(safe-area-inset-bottom, 0px))', left: '50%', transform: 'translateX(-50%)',
      width: 'min(520px, calc(100% - 28px))', display: 'flex', justifyContent: 'space-around',
      background: 'rgba(17, 19, 21, 0.96)', backdropFilter: 'blur(16px)',
      border: '1px solid #292D30', borderRadius: 30, padding: 7, zIndex: 100,
      boxShadow: '0 12px 40px rgba(0,0,0,.48)',
    }}>
      {tabs.map(({ id, icon, label }) => {
        const selected = active === id;
        return (
          <button
            key={id}
            type="button"
            aria-label={label}
            aria-current={selected ? 'page' : undefined}
            title={label}
            onClick={() => handleTab(id)}
            style={{
              flex: 1, minWidth: 0, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: selected ? 'linear-gradient(180deg, #B7FF00, #8FD900)' : 'transparent',
              border: 'none', borderRadius: 24, color: selected ? '#10130B' : '#9DA1A4',
              padding: 0, cursor: 'pointer', transition: 'background .18s ease, color .18s ease',
            }}
          >
            <span aria-hidden="true" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</span>
          </button>
        );
      })}
    </nav>
  );
}
